import { GlycemicControl } from './glycemic-types';

export class GlycemicService {
  static instance?: GlycemicControl;
}
